/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Results_LabelInputs */

const en_us2_search_results_label = /** @type {(inputs: Search_Results_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results`)
};

const pt_br2_search_results_label = /** @type {(inputs: Search_Results_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

const es_419_search_results_label = /** @type {(inputs: Search_Results_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

const pt_pt2_search_results_label = /** @type {(inputs: Search_Results_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados`)
};

const fr_fr2_search_results_label = /** @type {(inputs: Search_Results_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats`)
};

const de_de2_search_results_label = /** @type {(inputs: Search_Results_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse`)
};

const it_it2_search_results_label = /** @type {(inputs: Search_Results_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati`)
};

/**
* | output |
* | --- |
* | "Results" |
*
* @param {Search_Results_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_results_label = /** @type {((inputs?: Search_Results_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Results_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_results_label(inputs)
	if (locale === "es-419") return es_419_search_results_label(inputs)
	if (locale === "pt-PT") return pt_pt2_search_results_label(inputs)
	if (locale === "fr-FR") return fr_fr2_search_results_label(inputs)
	if (locale === "de-DE") return de_de2_search_results_label(inputs)
	if (locale === "it-IT") return it_it2_search_results_label(inputs)
	return en_us2_search_results_label(inputs)
});
export { search_results_label as "search.results_label" }